import common from '@/store/common/mutations';
import * as types from './mutation-types';
import moment from 'moment';

let startDate = moment().startOf('year');
let endDate = moment().startOf('month');

//화면 진입시 초기화
const getInit = () => {
	return {
		searchParams: {
			mmPrvs: '10', //월별항목
			srchMm01: '30', //판매월
			stdAnls: '10', //분석기준
			srchMm02: '20', //조건월
			idxScn: '', //지수구분
			carScn: '', //차량구분
			pacScn: '', //승상구분
			// plntCd: 'HCJ1', //생산공장
			flclSpc: '', //연료전지사양
			phmnCd: '', //현상코드
			// customPrCor: 'HTWO', //생산법인
			ctype: '', //클레임타입
			useTerm: '', //사용기간
			carTypeNm: '', //차종유형
			// saleNat: '', //판매국가
			occuRegn: '', //판매지역
			check: 'N', //누적
			opCd: '', //작업코드

			strtMm01: startDate, //strtMm01
			endMm01: endDate, //endMm01
			strtMm02: startDate, //strtMm02
			endMm02: endDate //endMm01
		},
		grdList1: [], // 탭1 그리드리스트
		dayCols: [], //그리드 컬럼(년월컬럼)
		barList: [], //탭1 막대그래프 리스트

		carTypeNmList: [], //검색 차종유형 셀렉트박스

		grdList2: [], // 탭2 그리드리스트
		grdList3: [], // 탭2 그리드리스트

		grdList4: [], // 탭3 그리드리스트
		grdList5: [], // 탭3 그리드리스트

		bcMaxVal: '', //바차트 Y축 최대값 추가

		isLoading1: false,
		isLoading2: false,
		isLoading3: false
	};
};

const selectDate1 = (state, { from, to }) => {
	state.searchParams.strtMm01 = from;
	state.searchParams.endMm01 = to;
};
const selectDate2 = (state, { from, to }) => {
	state.searchParams.strtMm02 = from;
	state.searchParams.endMm02 = to;
};

export default {
	...common,
	selectDate1,
	selectDate2,
	[types.STATE_INIT]: state => {
		//초기화
		Object.assign(state, getInit());
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	}
};
